// components/ErrorAlert.tsx
import React from 'react';
import './styles/ErrorAlert.css';

export const ErrorAlert = ({ statusCode, description }) => (
  <div className="error-alert">
    <div className="error-alert-title">Error {statusCode}</div>
    <div className="error-alert-description">{description}</div>
  </div>
);
